"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var workflow_designer_viewport_model_1 = require("../shared/workflow-designer-viewport.model");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var workflow_designer_types_1 = require("../shared/workflow-designer.types");
var WorkflowDesignerViewportComponent = /** @class */ (function () {
    function WorkflowDesignerViewportComponent(messageService, cd) {
        this.messageService = messageService;
        this.cd = cd;
        this.edit = new core_1.EventEmitter();
        this.viewport = new workflow_designer_viewport_model_1.WorkflowDesignerViewportModel();
    }
    WorkflowDesignerViewportComponent.prototype.ngAfterViewInit = function () {
        var rect = this.viewportContainer.nativeElement.getBoundingClientRect();
        this.viewport.width = rect.width;
        this.viewport.height = rect.height;
        this.cd.detectChanges();
    };
    WorkflowDesignerViewportComponent.prototype.onMouseWheel = function (e) {
        if (this.viewport.scrollZoomEnabled) {
            if (e.wheelDelta > 0) {
                this.viewport.zoom += 0.1;
            }
            else {
                this.viewport.zoom -= 0.1;
            }
            return false;
        }
        return true;
    };
    WorkflowDesignerViewportComponent.prototype.onRightClick = function (e) {
        e.preventDefault();
    };
    WorkflowDesignerViewportComponent.prototype.handleKeyboardEvent = function (event) {
        var code = event.keyCode;
        //console.log(code);
        switch (code) {
            case 65:
                if (this.viewport.selected && this.viewport.selected.type === workflow_designer_types_1.WorkflowDesignerType.ACTION && !this.viewport.selected.start) {
                    var begin = this.viewport.selected.begin;
                    var beginOrigin = this.viewport.selected.beginOrigin;
                    this.viewport.selected.begin = this.viewport.selected.end;
                    this.viewport.selected.end = begin;
                    this.viewport.selected.beginOrigin = this.viewport.selected.endOrigin;
                    this.viewport.selected.endOrigin = beginOrigin;
                }
                break;
            case 66:
                if (this.viewport.selected && this.viewport.selected.type === workflow_designer_types_1.WorkflowDesignerType.ACTION) {
                    this.viewport.selected.beginOrigin = ((this.viewport.selected.beginOrigin || 0) + 1) % 8;
                }
                if (this.viewport.process.actions[0] && this.viewport.selected && this.viewport.selected.type === workflow_designer_types_1.WorkflowDesignerType.START) {
                    this.viewport.process.actions[0].beginOrigin = ((this.viewport.process.actions[0].beginOrigin || 0) + 1) % 8;
                }
                break;
            case 67:
                this.viewport.resetView();
                break;
            case 68:
                if (this.viewport.selected && (this.viewport.selected.type === workflow_designer_types_1.WorkflowDesignerType.ACTION || this.viewport.selected.type === workflow_designer_types_1.WorkflowDesignerType.ACTION_START)) {
                    this.viewport.selected.beginOrigin = null;
                    this.viewport.selected.endOrigin = null;
                }
                if (this.viewport.process.actions[0] && this.viewport.selected && this.viewport.selected.type === workflow_designer_types_1.WorkflowDesignerType.START) {
                    this.viewport.process.actions[0].beginOrigin = null;
                    this.viewport.process.actions[0].endOrigin = null;
                }
                break;
            case 69:
                if (this.viewport.selected && this.viewport.selected.type === workflow_designer_types_1.WorkflowDesignerType.ACTION) {
                    this.viewport.selected.endOrigin = ((this.viewport.selected.endOrigin || 0) + 1) % 8;
                }
                if (this.viewport.process.actions[0] && this.viewport.selected && this.viewport.selected.type === workflow_designer_types_1.WorkflowDesignerType.START) {
                    this.viewport.process.actions[0].endOrigin = ((this.viewport.process.actions[0].endOrigin || 0) + 1) % 8;
                }
                break;
            case 71:
                this.viewport.showGrid = !this.viewport.showGrid;
                break;
            case 82:
                this.viewport.resizeEnabled = !this.viewport.resizeEnabled;
                break;
            case 83:
                this.viewport.snapToGrid = !this.viewport.snapToGrid;
                break;
            case 90:
                this.viewport.scrollZoomEnabled = !this.viewport.scrollZoomEnabled;
                break;
        }
    };
    WorkflowDesignerViewportComponent.prototype.getMessage = function (key) {
        return this.messageService.getMessage(key);
    };
    WorkflowDesignerViewportComponent.prototype.onMouseOver = function (e) {
    };
    WorkflowDesignerViewportComponent.prototype.onMouseOut = function (e) {
        if (this.viewport.dragging) {
            if (this.viewport.moved) {
                this.viewport.dragging.dragEnd && this.viewport.dragging.dragEnd(this.viewport);
            }
        }
        this.viewport.endDrag();
    };
    WorkflowDesignerViewportComponent.prototype.onResize = function (e) {
        var rect = this.viewportContainer.nativeElement.getBoundingClientRect();
        this.viewport.width = rect.width;
        this.viewport.height = rect.height;
    };
    WorkflowDesignerViewportComponent.prototype.onMouseDown = function (e) {
        var _this = this;
        this.viewport.mouseDown = true;
        this.viewport.selected = null;
        setTimeout(function () {
            if (!_this.viewport.selected) {
                _this.edit.emit(null);
            }
        }, 0);
    };
    WorkflowDesignerViewportComponent.prototype.onMouseUp = function (e) {
        if (this.viewport.dragging && e.button === 0) {
            if (this.viewport.moved) {
                this.viewport.dragging.dragEnd && this.viewport.dragging.dragEnd(this.viewport);
                this.edit.emit(this.viewport.dragging.onDrop && this.viewport.dragging.onDrop(this.viewport));
            }
            else {
                this.edit.emit(this.viewport.dragging.onEdit && this.viewport.dragging.onEdit(this.viewport));
            }
        }
        this.viewport.endDrag();
    };
    WorkflowDesignerViewportComponent.prototype.onMouseMove = function (e) {
        if (this.viewport.mouseDown) {
            if (this.viewport.dragging) {
                if (!this.viewport.moved) {
                    this.viewport.dragging.dragStart && this.viewport.dragging.dragStart(this.viewport);
                }
                this.viewport.moved = true;
                this.viewport.dragging.move && this.viewport.dragging.move(e.movementX / this.viewport.zoom, e.movementY / this.viewport.zoom, this.viewport.snapToGrid ? 10 : 1, this.viewport);
                this.viewport.dragging.moveUnscaled && this.viewport.dragging.moveUnscaled(e.movementX, e.movementY);
            }
            else {
                this.viewport.move(e.movementX, e.movementY);
            }
        }
        this.viewport.cursorX = e.layerX / this.viewport.zoom - this.viewport.x / this.viewport.zoom;
        this.viewport.cursorY = e.layerY / this.viewport.zoom - this.viewport.y / this.viewport.zoom;
    };
    WorkflowDesignerViewportComponent.decorators = [
        { type: core_1.Component, args: [{
                    
                    selector: 'sis-workflow-designer-viewport',
                    template: require('./sis-workflow-designer-viewport.component.html'),
                    styles: [require('./sis-workflow-designer-viewport.component.css')]
                },] },
    ];
    /** @nocollapse */
    WorkflowDesignerViewportComponent.ctorParameters = function () { return [
        { type: idm_message_language_service_client_js_1.MessageService, },
        { type: core_1.ChangeDetectorRef, },
    ]; };
    WorkflowDesignerViewportComponent.propDecorators = {
        "edit": [{ type: core_1.Output },],
        "viewport": [{ type: core_1.Input },],
        "viewportContainer": [{ type: core_1.ViewChild, args: ['viewportContainer',] },],
        "onMouseWheel": [{ type: core_1.HostListener, args: ['mousewheel', ['$event'],] },],
        "onRightClick": [{ type: core_1.HostListener, args: ['contextmenu', ['$event'],] },],
        "handleKeyboardEvent": [{ type: core_1.HostListener, args: ['document:keypress', ['$event'],] },],
        "onMouseOver": [{ type: core_1.HostListener, args: ['mouseover', ['$event'],] },],
        "onMouseOut": [{ type: core_1.HostListener, args: ['mouseleave', ['$event'],] },],
        "onResize": [{ type: core_1.HostListener, args: ['window:resize', ['$event'],] },],
        "onMouseDown": [{ type: core_1.HostListener, args: ['mousedown', ['$event'],] },],
        "onMouseUp": [{ type: core_1.HostListener, args: ['mouseup', ['$event'],] },],
        "onMouseMove": [{ type: core_1.HostListener, args: ['mousemove', ['$event'],] },],
    };
    return WorkflowDesignerViewportComponent;
}());
exports.WorkflowDesignerViewportComponent = WorkflowDesignerViewportComponent;
//# sourceMappingURL=sis-workflow-designer-viewport.component.js.map